module.exports = require("@swa-ui/core/src/Autocomplete/Autocomplete.module.scss");